<template>
  <gmap-map
    style="height: 100%; width: 100%"
    ref="mapPanneau"
    :center="centerDefault"
    :zoom="zoomDefault">
    <gmap-marker
      :position="panneau.adresse.coordonnees"
      :icon="getIconPanneau(panneau)">
    </gmap-marker>
  </gmap-map>
</template>

<script>
import { CENTER_DEFAULT } from '@/configurations/configurationCarto';
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/gestionIconMarker/iconColorGetter';

export default {
  props: {
    streetView: Boolean,
    panneau: Object,
  },
  data() {
    return {
      centerDefault: CENTER_DEFAULT,
      zoomDefault: 7
    }
  },
  methods: {
    async initStreetViewMap() {
      const map = await this.$refs.mapPanneau.$mapPromise;
      const panorama = map.getStreetView();
      panorama.setPov(({
        heading: 265,
        pitch: 0
      }));
      panorama.addListener('visible_changed',() => {
        this.$parent.streetView = panorama.getVisible();
      });
      panorama.setPosition(this.panneau.adresse.coordonnees);
      panorama.setVisible(true);
    },
    getIconPanneau(panneau) {
      return iconColorGetter(panneau.couleur, TAILLE_ICON_GRAND, panneau.azimut, true);
    },
  },
  async mounted() {
    await this.initStreetViewMap();
  }
};
</script>

<style>

</style>